var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","fill":"#fff","key":0},[React.createElement("path",{"d":"M0 37.996V0h15.012C21.86.022 26.64 4.916 26.59 11.92a18.101 18.101 0 01-.523 4.579c-1.037 3.87-3.672 6.191-7.369 7.29-2.989.89-6.05.34-9.14.492v-6.334h4.768c5.599.156 6.72-5.037 5.48-8.413a4.563 4.563 0 00-1.585-2.198 4.384 4.384 0 00-2.525-.877c-3.04-.155-6.096-.043-9.232-.043V31.74h43.62L24.17.255h8.31L64 37.995H0zM48.04 13.883L44.06 9.28c2.424-3.066 4.818-6.105 7.23-9.154h7.946L48.04 13.883z","key":0}),React.createElement("path",{"d":"M28.241 29.18l7.736-9.374 4.081 4.717-3.672 4.653-8.145.004z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h64v38H0z"})))]);
}

LogoInline.defaultProps = {"viewBox":"0 0 64 38","width":"64","height":"38","fill":"none"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
